const quoteFactStyle ={
  quoteFact: {
    "& .fact:nth-child(2n)": {
        textAlign: "right"
    }
  }
}

export default quoteFactStyle;